export const PRODUCT_TAB = {
  PC_AND_TABLET: {
    MIN_ITEM_HEIGHT: 160,
    IMAGE_WIDTH: 224,
    IMAGE_HEIGHT: 126,
  },
  SP: {
    MIN_ITEM_HEIGHT: 110,
    IMAGE_WIDTH: 132,
    IMAGE_HEIGHT: 74,
  },
} as const;
